<app-form-group>
    <table class="skv-table skv-table--minimal">
        <ng-content></ng-content>
    </table>
</app-form-group>